<ng-container *ngIf="{ link: navLinks$ | async, deviceType: deviceType$ | async } as headerNavData">
  <ng-container *ngIf="headerNavData.deviceType === 'desktop'; else generalView">
    <!-- Desktop View -->
    <custom-dot-cms-desktop-view-header-navigation
      [navLinks]="headerNavData.link"
    ></custom-dot-cms-desktop-view-header-navigation>
  </ng-container>
  <!-- Mobile and Tablet View -->
  <ng-template #generalView>
    <custom-dot-cms-general-view-header-navigation
      [navLinks]="headerNavData.link"
    ></custom-dot-cms-general-view-header-navigation>
  </ng-template>
</ng-container>
